import { render, staticRenderFns } from "./NetworkTag.vue?vue&type=template&id=2251a73c&scoped=true"
import script from "./NetworkTag.vue?vue&type=script&lang=ts"
export * from "./NetworkTag.vue?vue&type=script&lang=ts"
import style0 from "./NetworkTag.vue?vue&type=style&index=0&id=2251a73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251a73c",
  null
  
)

export default component.exports